import React, {  useEffect } from 'react';
import AsideLeft from './AppAdminComponents/AsideLeft';
import NavBarNotificationBar from './AppAdminComponents/NavBarNotificationBar';
import { useForm } from "react-hook-form";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css"
import Footer from '../components/Footer';

export default function Profile() {

    const { register, handleSubmit, errors } = useForm();
    const onSubmit = data => console.log(data);


    useEffect(() => {

    }, [])

    

    return (
        <>

            <div className="wrapper">
                {/* Navbar */}
                <nav className="main-header navbar navbar-expand navbar-white navbar-light">
                    <NavBarNotificationBar />
                </nav>
                <AsideLeft option="profile" />
                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-6">
                                    <h1 className="m-0 text-dark">Profile</h1>
                                </div>
                            </div>
                        </div>
                    </div>
                    <section className="content">
                        <div className="container-fluid">
                            <div className="row">
                                {/* Left col */}
                                <section className="col-lg-12 connectedSortable">
                                    {/* Custom tabs (Charts with tabs)*/}
                                    <div className="card">
                                        <div className="card-header">

                                        </div>
                                        <div className="card-body">

                                            <div className="tab-content p-0">
                                                <form onSubmit={handleSubmit(onSubmit)}>
                                                    <div className="row">
                                                        <div className="col-12">
                                                            <div className="form-group">
                                                                <label >Senha</label>
                                                                <input type="text" name="password" className="form-control" aria-describedby="password"  ref={register({ required: true })} />
                                                                {errors.nome && <span>Campo obrigatório</span>}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-12">
                                                            <div className="form-group">
                                                                <label >Confirmar Senha</label>
                                                                <input type="text" name="password_confirm" className="form-control" aria-describedby="password"  ref={register({ required: true })} />
                                                                {errors.nome && <span>Campo obrigatório</span>}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <input type="submit" /> 
                                                </form>
                                            </div>

                                        </div>
                                    </div>
                                </section>

                            </div>
                        </div>
                    </section>
                </div>

                <Footer />
            </div>
        </>
    )
}
